<div class="page-root">
  <div class="title">
    <mat-icon>lock</mat-icon>
  </div>

  <div class="title">
    <div class="typo-h1">{{ 'passwordReset.title' | transloco }}</div>
  </div>

  <div class="body">
    <div class="body-text">
      {{ "passwordReset.subtitle" | transloco }}
    </div>

    <mat-form-field class="form-field" subscriptSizing="dynamic">
      <mat-label>{{ "form.label.email" | transloco }}</mat-label>
      <input [formControl]="email" matInput/>
      <mat-icon matSuffix>email</mat-icon>
    </mat-form-field>
  </div>

  <div class="actions">
    <app-text-button (click)="resetPassword()" [text]="'passwordReset.button' | transloco" colorVariant="primary" trailingIcon="check_circle" type="rounded"></app-text-button>
    <app-text-button mat-dialog-close [text]="'button.cancel' | transloco" colorVariant="outlined-neutral" leadingIcon="close"></app-text-button>
  </div>
</div>
